import React, { useMemo, useState } from 'react';
import { Form } from 'react-bootstrap';
import { gainssTestCaseFields } from '../../../static-data/DropdownOptions';
import TableComponent from '../../../ui/data/table/TableComponent';

export const fieldsRemovedFromMapping = ['Key', 'id', 'SNo', 'Automated On', 'Step No.'];

const UploadColumnMapping = ({
  csvData,
  columnMapping,
  handleMappingChange,
  hasAutomationFields = true,
}) => {
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);

  const selectedFields = useMemo(() => new Set(Object.values(columnMapping)), [columnMapping]);

  const csvFields = useMemo(() => {
    if (!csvData?.length) return [];
    return Object.keys(csvData[0]).filter(
      (csvField) => !fieldsRemovedFromMapping.includes(csvField)
    );
  }, [csvData]);

  const tableData = useMemo(
    () => csvFields.map((csvField) => ({ id: csvField, csvField })),
    [csvFields]
  );

  const headerTabs = useMemo(
    () => [
      {
        key: 'csvField',
        label: 'CSV Field',
        minWidth: 200,
        formatContent: (row) => row.csvField,
      },
      {
        key: 'arrow',
        label: '',
        minWidth: 40,
        formatContent: () => <span style={{ display: 'block', textAlign: 'center' }}>→</span>,
      },
      {
        key: 'gainssField',
        label: 'Gainss Field',
        minWidth: 280,
        formatContent: (row) => (
          <Form.Select
            name={row.csvField}
            onChange={handleMappingChange}
            value={columnMapping[row.csvField] || ''}>
            <option value="">None</option>
            {gainssTestCaseFields
              .filter((field) => {
                const isAutomation = [
                  'isAutomated',
                  'automatedBy',
                  'automationMethod',
                ].includes(field.key);
                return hasAutomationFields ? true : !isAutomation;
              })
              .map((field) => (
                <option
                  key={field.key}
                  value={field.key}
                  disabled={
                    selectedFields.has(field.key) &&
                    columnMapping[row.csvField] !== field.key
                  }
                >
                  {field.label}
                </option>
              ))}
          </Form.Select>
        ),
      },
    ],
    [columnMapping, handleMappingChange, hasAutomationFields, selectedFields]
  );

  return (
    <TableComponent
      data={tableData}
      headerTabs={headerTabs}
      tablekey="column mapping"
      page={1}
      perPage={tableData.length}
      totalCount={tableData.length}
      handlePageChange={() => {}}
      showPages={false}
      showCheckbox={false}
      isLoading={false}
      striped
      order={order}
      setOrder={setOrder}
      selected={selected}
      setSelected={setSelected}
    />
  );
};

export default UploadColumnMapping;